<template>
    <div class="card">
        <div class="card-header">
            <i class="fas fa-object-group me-2"></i>{{ TR.category }}
        </div>

        <div class="card-body">
            <DADataTable
                ref="category_table_ref"
                v-if="tableOptions"
                :tableData="tableData"
                :tableOptions="tableOptions"
            />
        </div>
    </div>
</template>


<script scoped>
    import { onBeforeMount, ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";
    import moment from 'moment-timezone';

    import { G, ajax } from "@/_common";
    import DADataTable from "@/components/table/DADataTable";

    export default {
        title: "category",
        name: 'CategoryP',
        components: {
            DADataTable,
        },
        setup() {
            const store = useStore();

            const tableData = ref([]);
            const tableOptions = ref();
            const filter_groups = ref([]);
            const category = ref([]);
            const category_table_ref = ref();
            const TR = ref({});

            onBeforeMount(async () => {
                await ajax({
                    url: store.getFilterList(),
                    success: (e) => {
                        const res = e.data || null;
                        if (res) {
                            filter_groups.value = res.map((a) => {
                                return { value: a.id, label: a.translate[0].name };
                            });
                        }
                    }
                });

                await ajax({
                    url: store.getCategory(),
                    success: (e) => {
                        let res = e.data || null;
                        if (res) {
                            category.value = [];
                            category.value.push({ value: 0, label: `<b>${TR.value.main}</b>` });
                            category.value = category.value.concat(res.map((e) => {
                                return { value: e.id, label: e.translate[0].name };
                            }));
                            tableData.value = res;
                            // console.log(res[0].create_date, G.systemData.timezone?.value);
                            // console.log(moment.utc(res[1].create_date), moment.utc(res[1].create_date).tz(G.systemData.timezone?.value));


                            // tableData.value.forEach(x => x.create_date = new Date(x.create_date));
                            // tableData.value.forEach(x => x.create_date = new Date(moment.utc(x.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss")));
                        }
                    }
                });

            });


            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    // row_total: false,
                    // row_per_page: 5,

                    header_buttons: [
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: "fas fa-plus me-1",
                            class: "btn-primary",
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    // subTitle: `<span class="text-danger1">${TR.value.name}</span>`,
                                    page: "components/table/DynamicTable2",
                                    data: {
                                        permission_method: 'add'
                                    },
                                    table_columns_forlang: [
                                        {
                                            name: "name",
                                            title: TR.value.name,
                                            field_type: "text",
                                            required: true,
                                        },
                                        {
                                            name: "description",
                                            title: TR.value.about,
                                            field_type: "editor",
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            // value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            // fileSelectMode: 'advanced',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        // {
                                        //     name: "name",
                                        //     title: TR.value.name,
                                        //     field_type: "text",
                                        //     required: true,
                                        // },
                                        {
                                            name: "code",
                                            title: TR.value.code,
                                            field_type: 'text',
                                        },
                                        {
                                            name: "parent",
                                            title: TR.value.parent,
                                            field_type: 'dropdown',
                                            dropdown_items: category.value,
                                            dropdown_item_selected: 0
                                        },
                                        // {
                                        //     name: "filter_groups",
                                        //     title: TR.value.filter,
                                        //     field_type: "multiselect",
                                        //     dropdown_items: filter_groups.value,
                                        //     dropdown_item_selected: [],
                                        //     // onChange: (e, s) => {
                                        //     //     console.log(s, e);
                                        //     //     (document.getElementById('EventTypeSelection')
                                        //     //         .getElementsByClassName('ui-multiselect-label-container')[0]
                                        //     //         .getElementsByClassName('ui-multiselect-label')[0]).textContent = this.SelectedEventTypes.length + ' ausgewählt';
                                        //     // }
                                        // },
                                        {
                                            name: "rank",
                                            title: TR.value.rank,
                                            value: () => 1,
                                            field_type: 'integer',
                                            max: 10000,
                                            // default: 1
                                        },
                                        {
                                            name: "color",
                                            title: TR.value.color,
                                            value: () => { return {'r':3,'g':68,'b':108} },
                                            field_type: 'color',
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: () => true,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.name[1] != '' ){
                                                            let formData = new FormData();

                                                            if( e.image != null && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }

                                                            let category_data = {
                                                                "code": e.code || e.name[1],
                                                                "parent": e.parent,
                                                                "rank": e.rank,
                                                                "status": e.status,
                                                                "color": `${e.color.r},${e.color.g},${e.color.b}`,
                                                                // "filter_groups": e.filter_groups,
                                                                "translate": G.lang_list.map((a) => ({
                                                                    "lang_id": a.value,
                                                                    "name": e.name[a.value] || e.name[1],
                                                                    "description": e.description[a.value] || e.description[1],
                                                                })),
                                                            };
                                                            if( e.image != null && typeof e.image !== 'object' )
                                                                category_data.image = e.image;

                                                            formData.append("data", JSON.stringify(category_data));

                                                            await ajax({
                                                                url: store.getCategory(),
                                                                method: 'post',
                                                                data: formData,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if ( x.status == 200 && res) {
                                                                        res.create_date = new Date(res.create_date);
                                                                        category.value.push({ value: res.id, label: res.translate[0].name });
                                                                        tableData.value.push(res);

                                                                        G.alert.success({msg: TR.value.msg_add_success});
                                                                    }
                                                                    else
                                                                        G.alert.error({msg: res.detail});
                                                                },
                                                                // error: (x) => {
                                                                //     var res = x.response || {};
                                                                //     if( res.status && res.status == 422 ){
                                                                //         G.alert.error({title: TR.value.warning, msg: G.getErrorMessages(res.data.detail)});
                                                                //     }
                                                                //     else
                                                                //         G.alert.error({msg: TR.value.msg_add_failed});
                                                                // }
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_name});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    row_buttons: [
                        {
                            private: G.privateIfNotPermission("remove"),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                // toast.removeAllGroups()
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_are_you_sure, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getCategoryUpdate(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            let res = e.data || null;
                                            if ( e.status == 200 && res){
                                                tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                                                category.value.filter((x, i) => { if (x.value === data.id) category.value.splice(i, 1); } );
                                                G.alert.success(res.detail);
                                            }
                                            else
                                                G.alert.error(res.detail);
                                        },
                                        // error: (e) => {
                                        //     let res = e.response || null;
                                        //     if( res.status && res.status == 422 ){
                                        //         G.alert.warning(G.getErrorMessages(res.data.detail));
                                        //     }
                                        //     else
                                        //         G.alert.error(TR.value.msg_remove_failed);
                                        // }
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {} })
                            },
                        },
                        {
                            // private: G.privateIfNotPermission("update"),
                            label: "",
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: (data) => {
                                data.permission_method = 'update';

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: `${data.translate[0].name}`,
                                    dismiss: false,
                                    page: "components/table/DynamicTable2",
                                    data: data,
                                    table_columns_forlang: [
                                        {
                                            name: "name",
                                            value: (l) => l.name,
                                            title: TR.value.name,
                                            field_type: 'text',
                                            required: true,
                                        },
                                        {
                                            name: "description",
                                            title: TR.value.about,
                                            value: (l) => l.description,
                                            field_type: "editor",
                                        },
                                    ],
                                    table_columns: [
                                        {
                                            name: "preview_image",
                                            title: TR.value.preview,
                                            // value: (e) => e.image,
                                            value: "image",
                                            field_type: "label",
                                        },
                                        {
                                            name: "image",
                                            title: TR.value.image,
                                            value: (e) => e.image,
                                            field_type: "image",
                                            fileSelectMode: 'basic',
                                            fileMaxSize: G.uploadedFileSize,
                                            fileLimit: 1,
                                            fileMultiple: false,
                                        },
                                        {
                                            name: "remove_image",
                                            field_type: "element",
                                            buttons: [
                                                {
                                                    name: "remove",
                                                    type: "button",
                                                    icon: "fas fa-trash me-2",
                                                    class: "btn btn-danger",
                                                    text: `${TR.value.image} ${TR.value.remove}`,
                                                    event: "click",
                                                    callback: (_, __, po) => {
                                                        po.newdata.preview_image = '';
                                                        po.newdata.image = '';
                                                        po.newdata.remove = true;
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        // {
                                        //     name: "name",
                                        //     value: (e) => e.translate[0].name,
                                        //     title: TR.value.name,
                                        //     field_type: 'text',
                                        //     required: true,
                                        // },
                                        {
                                            name: "code",
                                            value: "code",
                                            title: TR.value.code,
                                            field_type: 'text',
                                        },
                                        {
                                            name: "parent",
                                            value: "parent",
                                            title: TR.value.parent,
                                            // field_type: 'text',
                                            field_type: 'dropdown',
                                            dropdown_items: category.value.filter(e => e.value !== data.id),
                                            dropdown_item_selected: data.parent
                                        },
                                        // {
                                        //     name: "filter_groups",
                                        //     title: TR.value.filter,
                                        //     field_type: "multiselect",
                                        //     dropdown_items: filter_groups.value,
                                        //     // dropdown_item_selected: [filter_groups.value[0].value],
                                        //     dropdown_item_selected: data.filter_group_rel.map(c => c.filter_group_id),
                                        //     // onChange: (e, s) => {
                                        //     //     console.log(s, e);
                                        //     //     (document.getElementById('EventTypeSelection')
                                        //     //         .getElementsByClassName('ui-multiselect-label-container')[0]
                                        //     //         .getElementsByClassName('ui-multiselect-label')[0]).textContent = this.SelectedEventTypes.length + ' ausgewählt';
                                        //     // }
                                        // },
                                        {
                                            name: "rank",
                                            value: "rank",
                                            title: TR.value.rank,
                                            field_type: 'integer',
                                            max: 10000,
                                        },
                                        {
                                            name: "color",
                                            title: TR.value.color,
                                            value: (e) => {
                                                if( e.color && e.color != '' ){
                                                    let cl = e.color.split(',');
                                                    return {"r": parseInt(cl[0]), "g": parseInt(cl[1]), "b": parseInt(cl[2]) };
                                                }
                                                else return '';
                                            },
                                            field_type: 'color',
                                        },
                                        {
                                            name: "status",
                                            title: TR.value.status,
                                            value: (e) => e.status == 1 ? true : false,
                                            field_type: "switch",
                                            grouping: false,
                                            max: 30,
                                        },
                                        {
                                            name: "create_date",
                                            value: (e) => G.formatLocale(e.create_date),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if(e && e.name[1] != ''){
                                                            let formData = new FormData();
                                                            if( e.image != data.image && typeof e.image === 'object' ){
                                                                formData.append("upload_image", e.image);
                                                            }
                                                            let category_data = {
                                                                "code": e.code || e.name[1],
                                                                "parent": e.parent,
                                                                "rank": e.rank,
                                                                "status": e.status,
                                                                "color": `${e.color.r},${e.color.g},${e.color.b}`,
                                                                // "filter_groups": e.filter_groups,
                                                                "translate": G.lang_list.map((a) => (
                                                                    {
                                                                        "lang_id": a.value,
                                                                        "name": e.name[a.value] || e.name[1],
                                                                        "description": e.description[a.value] || e.description[1],
                                                                    }
                                                                )),
                                                            };
                                                            if( e.image != data.image && typeof e.image !== 'object' )
                                                                category_data.image = e.image;

                                                            formData.append("data", JSON.stringify(category_data));

                                                            await ajax({
                                                                url: store.getCategoryUpdate(data.id),
                                                                method: 'patch',
                                                                data: formData,
                                                                success: (x) => {

                                                                    let res = x.data || null;
                                                                    if (res) {
                                                                        res.create_date = new Date(res.create_date);
                                                                        tableData.value.forEach(
                                                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                                                        );
                                                                        for (let a in res) {
                                                                            data[a] = res[a];
                                                                        }
                                                                        category.value.forEach( c => {
                                                                            if(c.value == res.id) {
                                                                                c.value = res.id;
                                                                                c.label = res.translate[0].name;
                                                                            }
                                                                        });
                                                                        G.alert.success(TR.value.msg_update_success);
                                                                    }
                                                                },
                                                                // error: (x) => {
                                                                //     var res = x.response || {};
                                                                //     if( res.status == 422 ){
                                                                //         G.alert.warning(G.getErrorMessages(res.data.detail));
                                                                //     }
                                                                //     else
                                                                //         G.alert.error(res.data.detail);
                                                                // }
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else
                                                            G.alert.warning({msg: TR.value.msg_input_name});
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                        {
                            private: G.privateIfNotPermission("update"),
                            name: 'status',
                            title: TR.value.status,
                            value: (e) => e.status == 0 ? false : true,
                            class: 'text-center',
                            element: 'switch',
                            eventName: 'change',
                            eventCallback: async (data, event) => {
                                await ajax({
                                    url: store.getCategoryActivate(data.id, event.target.checked ? 1 : 0),
                                    method: 'post',
                                    success: (a) => {
                                        let res = a.data;
                                        G.alert.success({toast: true, msg: TR.value.msg_success});
                                        res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                                        tableData.value.forEach(
                                            (s) => { if ( s.id === res.id ) { s = res; } }
                                        );
                                        for (let a in res) {
                                            data[a] = res[a];
                                        }
                                    }
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        // {
                        //     name: 'status',
                        //     title: TR.value.status,
                        //     value: (e) => e.status == 0 ? false : true,
                        //     class: 'text-center',
                        //     element: 'switch',
                        //     eventName: 'change',
                        //     eventCallback: async (data, event) => {
                        //         await ajax({
                        //             url: store.getCategoryActivate(data.id, event.target.checked ? 1 : 0),
                        //             method: 'post',
                        //             success: (a) => {
                        //                 let res = a.data;
                        //                 G.alert.success({msg: TR.value.msg_update_success});
                        //                 res.create_date = new Date(moment.utc(res.create_date).tz(G.systemData.timezone?.value).format("YYYY-MM-DD HH:mm:ss"));
                        //                 tableData.value.forEach(
                        //                     (s) => { if ( s.id === res.id ) { s = res; } }
                        //                 );
                        //                 for (let a in res) {
                        //                     data[a] = res[a];
                        //                 }
                        //             }
                        //         });
                        //     },
                        //     // elementClass: 'bg-danger',
                        //     // attr: 'disabled',
                        //     // attrValue: true,
                        //     filter: false,
                        //     sortable: false,
                        //     exportable: false,
                        // },
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "image",
                            value: (e) => `<img src="${
                                                        e.image
                                                            ? e.image
                                                            : "/assets/img/noimg.png"
                                                    }"
                                                    alt="${e.image}"
                                                    class="border img-circle-cover"
                                                />`,
                            title: TR.value.image,
                            exportable: false,
                            sortable: false,
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "translate.0.name",
                            value: (e) => e.translate[0].name,
                            title: TR.value.name,
                        },
                        {
                            name: "code",
                            value: "code",
                            title: TR.value.code,
                        },
                        {
                            name: "parent",
                            value: "parent",
                            title: TR.value.parent,
                            class: 'text-center',
                            filter: false
                        },
                        {
                            name: "rank",
                            value: "rank",
                            title: TR.value.rank,
                            class: 'text-center',
                            filter: false
                        },
                        {
                            name: "color",
                            value: (e) => `<span style="padding: 3px 10px; background-color: rgb(${e.color})"></span>`,
                            title: TR.value.color,
                            class: "text-center",
                        },
                        {
                            name: "filter",
                            value: (e) => e.filter_group_rel.length > 0 ? '<i class="fas fa-check text-success" />' : '<i class="fas fa-square border text-white" />',
                            title: TR.value.filter_group,
                            class: 'text-center',
                            sortable: false,
                            filter: false
                        },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            class: 'text-center',
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            date_format: 'dd.mm.yy',
                            field_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };
            });

            return {
                TR,
                category_table_ref,
                tableData,
                tableOptions,
            };
        },
    };
</script>

